import { render, staticRenderFns } from "./ChurnReasonDialog.vue?vue&type=template&id=2a4b95bc&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ChurnReasonDialog.vue?vue&type=script&lang=js&"
export * from "./ChurnReasonDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChurnReasonDialog.vue?vue&type=style&index=0&id=2a4b95bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b95bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSelect,VTextarea})
